import {useEffect} from "react";
import {
    IMPORT_STEP_3,
    IMPORT_STEP_4,
    IMPORT_STEP_5, IMPORT_STEP_CANCELED,
    IMPORT_STEP_FAILED, useImportContext
} from "v4/pages/admin/Import/contexts/ImportContext";

export default function useImportRedirect(state) {
    const {updateStep} = useImportContext();

    useEffect(() => {
        switch (state) {
            case 'validation':
            case 'validated':
                updateStep(IMPORT_STEP_3);
                break;
            case 'generating':
            case 'processing':
                updateStep(IMPORT_STEP_4);
                break;
            case 'complete':
                updateStep(IMPORT_STEP_5);
                break;
            case 'failed':
                updateStep(IMPORT_STEP_FAILED);
                break;
            case 'canceled':
                updateStep(IMPORT_STEP_CANCELED);
                break;
            default:
                break;
        }
        // eslint-disable-next-line
    }, [state]);
}
